import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LeadFormDialog from "@/components/LeadFormDialog";
import HomePage from "@/pages/HomePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";

function App() {
  const [formOpen, setFormOpen] = useState(false);
  const openForm = () => setFormOpen(true);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <LeadFormDialog open={formOpen} onOpenChange={setFormOpen} />
      <Header onOpenForm={openForm} />
      <main>
        <Routes>
          <Route path="/" element={<HomePage onOpenForm={openForm} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
